<template>
	<div>
		<el-tooltip placement="right" :open-delay="open ? 1000 : 100">
			<div slot="content">{{ $t("organization") }}</div>
			<div class="item" @click="() => goTo(0)" :class="{ 'item-selected': selected.includes('profile') }">
				<md-icon
					:style="{
						color: selected.includes('profile') ? 'white' : '#cfd8dc',
						marginLeft: !open ? 'auto' : '',
						marginRight: !open ? 'auto' : ''
					}"
					>{{ "person" }}</md-icon
				>
				<span v-if="open">
					{{ $t("profile") }}
				</span>
			</div>
		</el-tooltip>
		<el-tooltip placement="right" :open-delay="open ? 1000 : 100">
			<div slot="content">{{ $t("your-users") }}</div>
			<div class="item" @click="() => goTo(1)" :class="{ 'item-selected': selected.includes('users') }">
				<md-icon
					:style="{
						color: selected.includes('users') ? 'white' : '#cfd8dc',
						marginLeft: !open ? 'auto' : '',
						marginRight: !open ? 'auto' : ''
					}"
					>people</md-icon
				>
				<span v-if="open">{{ $t("users") }}</span>
			</div>
		</el-tooltip>
		<el-tooltip placement="right" :open-delay="open ? 1000 : 100">
			<div slot="content">{{ $t("sitesettings") }}</div>
			<div class="item" @click="() => goTo(2)" :class="{ 'item-selected': selected.includes('sitesettings') }">
				<md-icon
					:style="{
						color: selected.includes('sitesettings') ? 'white' : '#cfd8dc',
						marginLeft: !open ? 'auto' : '',
						marginRight: !open ? 'auto' : ''
					}"
					>settings</md-icon
				>
				<span v-if="open">{{ $t("sitesettings") }}</span>
			</div>
		</el-tooltip>
		<el-tooltip placement="right" :open-delay="open ? 1000 : 100">
			<div slot="content">{{ $t("mailtest") }}</div>
			<div class="item" @click="() => goTo(3)" :class="{ 'item-selected': selected.includes('mailtest') }">
				<md-icon
					:style="{
						color: selected.includes('mailtest') ? 'white' : '#cfd8dc',
						marginLeft: !open ? 'auto' : '',
						marginRight: !open ? 'auto' : ''
					}"
					>email</md-icon
				>
				<span v-if="open">{{ $t("mailtest") }}</span>
			</div>
		</el-tooltip>
	</div>
</template>
<script>
import { goto } from "@/utils/utils"
const router = [
	{ name: "settings.profile" },
	{ name: "settings.users" },
	{ name: "settings.sitesettings" },
	{ name: "settings.mailtest" }
]
export default {
	name: "full-administrator-sidebar",
	props: ["open"],
	computed: {
		selected: function () {
			return this.$route.name
		}
	},
	methods: {
		goto,
		goTo: function (where) {
			this.$router
				.push(router[where])
				.then(res => {
					return true
				})
				.catch(err => {
					return false
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-sidebar";
</style>
